interface SubCategoriesType {
  [key: string]: string;
}

export type MajorCategory = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H' | 'I' | 'J' | 'K' | 'L' | 'M' | 'N' | 'O' | 'P' | 'Q' | 'R' | 'S' | 'T';

const generateCodes = (count: number, startIndex: number): string[] => Array.from({ length: count }, (_, i) => (i + startIndex).toString().padStart(2, '0'));

export const industryData: Record<MajorCategory, { name: string; codes: string[] }> = {
  A: { name: "農業、林業", codes: ["01", "02"] },
  B: { name: "漁業", codes: ["03", "04"] },
  C: { name: "鉱業、採石業、砂利採取業", codes: ["05"] },
  D: { name: "建設業", codes: ["06", "07", "08"] },
  E: { name: "製造業", codes: generateCodes(24, 9) },
  F: { name: "電気・ガス・熱供給・水道業", codes: generateCodes(4, 33) },
  G: { name: "情報通信業", codes: generateCodes(5, 37) },
  H: { name: "運輸業，郵便業", codes: generateCodes(8, 42) },
  I: { name: "卸売業，小売業", codes: generateCodes(12, 50) },
  J: { name: "金融業，保険業", codes: generateCodes(6, 62) },
  K: { name: "不動産業，物品賃貸業", codes: generateCodes(3, 68) },
  L: { name: "学術研究，専門・技術サービス業", codes: generateCodes(4, 71) },
  M: { name: "宿泊業，飲食サービス業", codes: generateCodes(3, 75) },
  N: { name: "生活関連サービス業，娯楽業", codes: generateCodes(3, 78) },
  O: { name: "教育，学習支援業", codes: generateCodes(2, 81) },
  P: { name: "医療，福祉", codes: generateCodes(3, 83) },
  Q: { name: "複合サービス事業", codes: generateCodes(2, 86) },
  R: { name: "サービス業（他に分類されないもの）", codes: generateCodes(9, 88) },
  S: { name: "公務（他に分類されるものを除く", codes: generateCodes(2, 97) },
  T: { name: "分類不能の産業", codes: ["00"] },
};

export const subCategories: SubCategoriesType = {
  "01": "農業",
  "02": "林業",
  "03": "漁業",
  "04": "水産養殖業",
  "05": "鉱業、採石業、砂利採取業",
  "06": "総合工事業",
  "07": "職別工事業",
  "08": "設備工事業",
  "09": "食料品製造業",
  "10": "飲料・たばこ・飼料製造業",
  "11": "繊維工業",
  "12": "木材・木製品製造業",
  "13": "家具・装備品製造業",
  "14": "パルプ・紙・紙加工品製造業",
  "15": "印刷・同関連業",
  "16": "化学工業",
  "17": "石油製品・石炭製品製造業",
  "18": "プラスチック製品製造業",
  "19": "ゴム製品製造業",
  "20": "なめし革・同製品・毛皮製造業",
  "21": "窯業・土石製品製造業",
  "22": "鉄鋼業",
  "23": "非鉄金属製造業",
  "24": "金属製品製造業",
  "25": "はん用機械器具製造業",
  "26": "生産用機械器具製造業",
  "27": "業務用機械器具製造業",
  "28": "電子部品・デバイス・電子回路製造業",
  "29": "電気機械器具製造業",
  "30": "情報通信機械器具製造業",
  "31": "輸送用機械器具製造業",
  "32": "その他の製造業",
  "33": "電気業",
  "34": "ガス業",
  "35": "熱供給業",
  "36": "水道業",
  "37": "通信業",
  "38": "放送業",
  "39": "情報サービス業",
  "40": "インターネット附随サービス業",
  "41": "映像・音声・文字情報制作業",
  "42": "鉄道業",
  "43": "道路旅客運送業",
  "44": "道路貨物運送業",
  "45": "水運業",
  "46": "航空運輸業",
  "47": "倉庫業",
  "48": "運輸に附帯するサービス業",
  "49": "郵便業（信書便事業を含む）",
  "50": "各種商品卸売業",
  "51": "繊維・衣服等卸売業",
  "52": "飲食料品卸売業",
  "53": "建築材料，鉱物・金属材料等卸売業",
  "54": "機械器具卸売業",
  "55": "その他の卸売業",
  "56": "各種商品小売業",
  "57": "織物・衣服・身の回り品小売業",
  "58": "飲食料品小売業",
  "59": "機械器具小売業",
  "60": "その他の小売業",
  "61": "無店舗小売業",
  "62": "銀行業",
  "63": "協同組織金融業",
  "64": "貸金業，クレジットカード業等非預金信用機関",
  "65": "金融商品取引業，商品先物取引業",
  "66": "補助的金融業等",
  "67": "保険業（保険媒介代理業，保険サービス業を含む）",
  "68": "不動産取引業",
  "69": "不動産賃貸業・管理業",
  "70": "物品賃貸業",
  "71": "学術・開発研究機関",
  "72": "専門サービス業（他に分類されないもの）",
  "73": "広告業",
  "74": "技術サービス業（他に分類されないもの）",
  "75": "宿泊業",
  "76": "飲食店",
  "77": "持ち帰り・配達飲食サービス業",
  "78": "洗濯・理容・美容・浴場業",
  "79": "その他の生活関連サービス業",
  "80": "娯楽業",
  "81": "学校教育",
  "82": "その他の教育，学習支援業",
  "83": "医療業",
  "84": "保健衛生",
  "85": "社会保険・社会福祉・介護事業",
  "86": "郵便局",
  "87": "協同組合（他に分類されないもの）",
  "88": "廃棄物処理業",
  "89": "自動車整備業",
  "90": "機械等修理業",
  "91": "職業紹介・労働者派遣業",
  "92": "その他の事業サービス業",
  "93": "政治・経済・文化団体",
  "94": "宗教",
  "95": "その他のサービス業",
  "96": "外国公務",
  "97": "国家公務",
  "98": "地方公務",
  "00": "分類不能の産業"
};